import React from "react";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import Switch from "Common/Custom/Switch";
import FormSubmitButton from "Common/Custom/FormSubmitButton";

const CommunicationSettingsForm = ({
  fields,
  values,
  handleChange,
  handleSubmit,
  loading
}) => {
  return (
    <PageBody 
      onSubmit={handleSubmit} 
      headerchildren={
        <HeadingOne>Communication Preferences</HeadingOne>
      }
    >
      <div className="row">
        {fields.map((field) => {
          if (field.type === "switch") {
            return (
              <Switch
                key={field.name}
                values={values[field.name]}
                handleChange={handleChange}
                field={field}
                ValueOne="1"
                ValueTwo="0"
                LabelOne="Allowed"
                LabelTwo="Blocked"
              />
            );
          }
          return null;
        })}
      </div>

      <FormSubmitButton
        label="Save Preferences"
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

export default CommunicationSettingsForm;
